import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { Caisse } from './caisse';
import { crcaList } from './crca-list';

@Component({
    selector: 'app-caisse-auto-complete',
    templateUrl: 'caisse-auto-complete.component.html',
    styleUrls: ['caisse-auto-complete.component.scss'],
})
export class CaisseAutoCompleteComponent implements OnInit, OnChanges {
    @Input() defaultCaisse: Caisse;
    @Input() form: FormGroup = new FormGroup({});
    @Input() id: string;
    @Output() caisseSelected: EventEmitter<Caisse> = new EventEmitter<Caisse>();
    filteredOptions: Observable<any[]>;
    myControl = new FormControl();

    ngOnInit(): void {
        if (this.defaultCaisse) {
            this.caisseSelected.emit(this.defaultCaisse);
        }
        this.myControl.setValidators([Validators.required]);
        this.form.addControl('caisse', this.myControl);
        this.filteredOptions = this.myControl.valueChanges.pipe(
            filter((value) => value !== null),
            startWith(''),
            map((value) => (typeof value === 'string' ? value : value.name)),
            map((name) => (name ? this.filter(name) : crcaList))
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.defaultCaisse.currentValue !==
            changes.defaultCaisse.previousValue
        ) {
            this.myControl.setValue(changes.defaultCaisse.currentValue);
        }
    }

    displayFn(q: any): string {
        return q && q.name ? q.name : '';
    }

    onSelectionChange(event) {
        this.caisseSelected.emit(event.option.value);
    }

    onInputChange() {
        this.myControl.setErrors({ caisseIsNotSelected: true });
    }

    private filter(libelle: string): Caisse[] {
        const filterValue = libelle.toLowerCase();
        const normalizedValue = filterValue
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        const filteredOptionList: Caisse[] = crcaList.filter((option) => {
            const normalizedOption = option.name
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
            return normalizedOption.toLowerCase().includes(normalizedValue);
        });

        if (filteredOptionList.length === 0) {
            filteredOptionList.push({
                id: null,
                name: 'Pas de résultat.',
            });
        }

        return filteredOptionList;
    }
}
